import { Alert, AlertProps } from '@mui/material';
import { FC } from 'react';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';

export const AlertMessage: FC<IAlertMessage> = ({ type, message }) => {
  return (
    <Alert
      icon={<FaceRetouchingNaturalIcon />}
      severity={type}
      sx={{ marginBottom: '16px', borderRadius: '10px' }}
    >
      {message}
    </Alert>
  );
};

export interface IAlertMessage {
  message: string;
  type: AlertProps['severity'];
}
